import axios from "axios";

var common_axios = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`
});

common_axios.interceptors.request.use(config => {
  const token = localStorage.getItem("accessToken");
  config.headers['Authorization'] = token ? `Bearer ${token}` : '';
  return config;
});

export default common_axios;